import type { UtilityContext } from '@change-corgi/core/react/utilityContext';

import type { PetitionHeadlineBanditData } from 'src/app/pages/petitionDetails/shared/types';

import {
	GammaPetitionDetailsPageCopyLinkBanditVariant,
	type GammaPetitionDetailsPageCopyLinkBanditVariantQuery,
	type GammaPetitionDetailsPageCopyLinkBanditVariantQueryVariables,
	GammaPetitionDetailsPageFacebookBanditVariant,
	type GammaPetitionDetailsPageFacebookBanditVariantQuery,
	type GammaPetitionDetailsPageFacebookBanditVariantQueryVariables,
	GammaPetitionDetailsPageWhatsAppBanditVariant,
	type GammaPetitionDetailsPageWhatsAppBanditVariantQuery,
	type GammaPetitionDetailsPageWhatsAppBanditVariantQueryVariables,
} from './bandits.graphql';

export async function getFacebookBanditVariantText(
	slugOrId: string,
	variantName: string,
	{ gql: { fetch } }: UtilityContext,
): Promise<PetitionHeadlineBanditData | undefined> {
	const { data } = await fetch<
		GammaPetitionDetailsPageFacebookBanditVariantQuery,
		GammaPetitionDetailsPageFacebookBanditVariantQueryVariables
	>({
		query: GammaPetitionDetailsPageFacebookBanditVariant,
		variables: { slugOrId, variantName },
		rejectOnError: false,
	});
	return (data?.petition?.bandits.facebookHeadline.variants?.variant?.data || undefined) as
		| PetitionHeadlineBanditData
		| undefined;
}

export async function getWhatsappBanditVariantText(
	slugOrId: string,
	variantName: string,
	{ gql: { fetch } }: UtilityContext,
): Promise<PetitionHeadlineBanditData | undefined> {
	const { data } = await fetch<
		GammaPetitionDetailsPageWhatsAppBanditVariantQuery,
		GammaPetitionDetailsPageWhatsAppBanditVariantQueryVariables
	>({
		query: GammaPetitionDetailsPageWhatsAppBanditVariant,
		variables: { slugOrId, variantName },
		rejectOnError: false,
	});
	return (data?.petition?.bandits.whatsappHeadline.variants?.variant?.data || undefined) as
		| PetitionHeadlineBanditData
		| undefined;
}

export async function getCopylinkBanditVariantText(
	slugOrId: string,
	variantName: string,
	{ gql: { fetch } }: UtilityContext,
): Promise<PetitionHeadlineBanditData | undefined> {
	const { data } = await fetch<
		GammaPetitionDetailsPageCopyLinkBanditVariantQuery,
		GammaPetitionDetailsPageCopyLinkBanditVariantQueryVariables
	>({
		query: GammaPetitionDetailsPageCopyLinkBanditVariant,
		variables: { slugOrId, variantName },
		rejectOnError: false,
	});
	return (data?.petition?.bandits.copylinkHeadline.variants?.variant?.data || undefined) as
		| PetitionHeadlineBanditData
		| undefined;
}

export async function getHeadlineBanditVariantText(
	shareType: string,
	slugOrId: string,
	variantName: string,
	utilityContext: UtilityContext,
) {
	switch (shareType) {
		case 'wa':
			return getWhatsappBanditVariantText(slugOrId, variantName, utilityContext);
		case 'cl_':
			return getCopylinkBanditVariantText(slugOrId, variantName, utilityContext);
		case 'fb':
			return getFacebookBanditVariantText(slugOrId, variantName, utilityContext);
		default:
			return undefined;
	}
}
